export const TEXT_NODE_MIN_WIDTH = 180;
export const TEXT_NODE_MIN_HEIGHT = 45;
